import { GRAPHQL_URL, requestMiddleware } from './gatewayHelper';
import { GraphQLClient } from 'graphql-request';

export const client = new GraphQLClient(GRAPHQL_URL, {
  credentials: 'include',
  requestMiddleware: requestMiddleware,
});

export function appFetcher<TData, TVariables>(query: string, variables?: TVariables) {
  return async (): Promise<TData> => client.request<TData, any>(query, variables);
}
